export default __webpack_public_path__ + "static/media/random6.9245db67.jpeg";